module.exports = __webpack_public_path__ + "img/hiragana-book-design-Tashii-Designs.2901a16f.jpg";